<template>
    <div class="foreground"
        :class="{ blur: blur, darken: darken, 'outer-content': notAbsolute == false, 'not-absolute': notAbsolute }">

        <div :class="innerClass">

            <div class="dialogue"
                :style="{ width: width + 'px', height: height + 'px', top: top + 'px', left: left - 109 + 'px', position: notAbsolute ? 'relative' : 'absolute' }">

                <div class="dialogueback" :style="{ backgroundSize: width + 'px ' + height + 'px' }">
                    <slot></slot>
                </div>

            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    name: 'DialogueBox',
    props: {
        blur: Boolean,
        width: Number,
        height: Number,
        top: Number,
        left: Number,
        darken: Boolean,
        notAbsolute: Boolean,
    },
    computed: {
        innerClass() {

            if (this.notAbsolute) {
                return "not-absolute";
            }

            return "inner-content inner-content-scaled-down";
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/*End of round pop up*/
.dialogue {
    background-color: white;
    border-radius: 29px;
}

.dialogueback {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
}

.darken {
    background-color: rgba(64, 70, 94, 0.5);
}

.not-absolute {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
}
</style>